<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer :title="prefix + title">
        <b-card no-body>

            <b-card-body>
                <b-card bg-variant="light">
                    <div class="d-flex justify-content-end">

                        <b-button id="load-co-responsavel" class="ml-3 mr-4" size="sm" style="height: 60px" pill
                            variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="load-co-responsavel" title="Localizar"></b-tooltip>
                        </b-button>


                        <b-button id="novo-co-responsavel" class="ml-3 mr-4" size="sm" style="height: 60px" pill
                            variant="primary" @click="addPessoaIntent">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="plus" />
                            </div>
                            <b-tooltip target="novo-co-responsavel"
                                title="Adicionar novo co responsável..."></b-tooltip>

                        </b-button>
                    </div>

                    <b-table responsive class="mt-2" stacked="sm" small outlined sticky-header show-empty
                        :busy="this.busy" :items="this.records" :fields="tableFields">
                        <template #empty>
                            <p>Nenhum resultado encontrado</p>
                        </template>

                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>
                    </b-table>
                    <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página
                                {{ page }} de {{
                                    totalPage }} -
                                {{ total }} registros</b-col>
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                    :options="perPageOptions">
                                </b-form-select>
                            </b-col>
                        </b-col>
                        <b-col cols="6">
                            <div class="d-flex justify-content-end align-items-end">
                                <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                    :per-page="perPage" :total-rows="total"></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-card-body>
        </b-card>

        <Lg-finder-page-pessoa-modal @onSelect="addPessoa" ref="finderPessoa"
            :prefix="prefix + title + ' > '"></Lg-finder-page-pessoa-modal>

    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import moment from "moment"
import { ListResourceMixin, FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPagePessoaModal from "@/components/Modal/LgFinderPagePessoaModal.vue";


export default {
    components: {
        LgFinderPagePessoaModal
    },
    mixins: [ListResourceMixin, FormResourceMixin],

    props: {
        id: Number,
        prefix: {
            tipe: String,
            default: "",
        },

        title: {
            tipe: String,
            default: "Histórico Co Responsável",
        },

    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        async addPessoa(pessoa) {
            this.$refs.finderPessoa.showModal = false;
            this.busy = true;
            try {
                await this.$saveResource({ pessoa: pessoa.id, ibp: this.id }, "", false, {}, false, true);
            }
            finally {
                this.busy = false;
            }

            this.load();
        },

        async addPessoaIntent() {
            this.$refs.finderPessoa.show();
        },

        cancelar() {
            this.$emit('fecharModal');
        },
        async load() {

            this.params = {};
            this.params.ibp = this.id;
            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            });
        },


    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/historico-co-responsavel`);
        this.load();
    },
    computed: {

        tableFields() {
            return [
                { key: "ibp", label: "Produto" },
                { key: "pessoa", label: "Pessoa" },
                {
                    key: "dhCriacao",
                    label: "Data Inicial",
                    formatter: (data) => moment(String(data)).format("DD/MM/YYYY HH:mm:SS"),
                },
                {
                    key: "dataFinal",
                    label: "Data Final",
                    formatter: (data) => { if (!data || data == '') return ''; return moment(String(data)).format("DD/MM/YYYY HH:mm:SS") },
                },


            ];
        },
    },


}

</script>